import { FullyAnalyticalUser } from '../modules/app/hooks/api/types';

export const fullNameUsernameOrEmail = (user: FullyAnalyticalUser | any) => {
  if (!user) return '';
  if (user.full_name && user.full_name.length > 0) return user.full_name;
  if (user.fullName && user.fullName.length > 0) return user.fullName;

  if (
    user.username &&
    user.username.split('')?.filter((a: string) => a === '-')?.length !== 4
  )
    return user.username;

  return user.email;
};

export const usernameFullNameOrEmail = (user: FullyAnalyticalUser) => {
  if (
    user.username &&
    user.username.split('')?.filter((a) => a === '-')?.length !== 4
  )
    return user.username;

  if (user.full_name && user.full_name.length > 1) return user.full_name;
  if (user.fullName && user.fullName.length > 1) return user.fullName;

  return user.email;
};

export const hasUsername = (user: { username?: string }) => {
  return (
    user.username &&
    user.username.split('')?.filter((a) => a === '-')?.length !== 4
  );
};

export const hasEmail = (user: { email?: string; has_email?: boolean }) => {
  return user.has_email || (user.email && !user.email.includes('@stemi.edu'));
};
